import React from "react"

import EmptyStar from "../../../icons/EmptyStar.svg"
import FullStar from "../../../icons/FullStar.svg"

export const renderStars = score => {
  // const remainder = score % 1
  const flooredScore = Math.floor(score)
  const stars = []

  for (let i = 0; i < flooredScore; i++) {
    stars.push(<FullStar key={`${i}-staricon`} />)
  }

  if (5 - flooredScore && score <= 4) {
    const emptyStars = 5 - flooredScore

    for (let i = 0; i < emptyStars; i++) {
      stars.push(<EmptyStar key={`${i}-starbordericon`} />)
    }
  }

  return stars
}

export default renderStars
